import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ccard" }
const _hoisted_2 = { class: "ccard__main" }
const _hoisted_3 = { class: "ccard__title-section" }
const _hoisted_4 = { class: "ccard__title" }
const _hoisted_5 = {
  key: 0,
  class: "ccard__likes-wrapper"
}
const _hoisted_6 = { class: "ccard__author-section" }
const _hoisted_7 = { class: "ccard__name-date-section" }
const _hoisted_8 = { class: "ccard__author" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "•", -1)
const _hoisted_10 = {
  key: 0,
  class: "ccard__date",
  style: { 'margin-right': '0.4rem' }
}
const _hoisted_11 = {
  key: 1,
  class: "ccard__updated-block"
}
const _hoisted_12 = { class: "ccard__pin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_IconPen = _resolveComponent("IconPen")!
  const _component_IconBookmark = _resolveComponent("IconBookmark")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_shiny_border = _resolveDirective("shiny-border")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.item.dbId)
        ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/build/' + _ctx.item.dbId,
            target: "_blank",
            class: "build__link"
          }, null, 8, ["to"])), [
            [_directive_ripple]
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.item.data.name), 1),
        (_ctx.item.data.likesAmount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_IconBase, {
                class: "ccard__heart-icon",
                height: 10
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconHeart)
                ]),
                _: 1
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.item.data.likesAmount), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_UserAvatar, {
          class: "ccard__pfp",
          "display-name": _ctx.loadedUserData.displayName,
          "photo-u-r-l": _ctx.loadedUserData.photoURL,
          "email-hash": _ctx.loadedUserData.emailHash,
          "avatar-provider": _ctx.loadedUserData.avatarProvider
        }, null, 8, ["display-name", "photo-u-r-l", "email-hash", "avatar-provider"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.loadedUserData.displayName), 1),
          _hoisted_9,
          (!_ctx.item.data.updatedAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(new Date(_ctx.item.data.createdAt.seconds * 1000).toLocaleDateString()), 1))
            : _createCommentVNode("", true),
          (
							_ctx.item.data.updatedAt &&
							!_ctx.isSameDay(_ctx.item.data.updatedAt, _ctx.item.data.createdAt)
						)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createVNode(_component_IconBase, { height: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconPen)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", null, _toDisplayString(new Date(
									_ctx.item.data.updatedAt.seconds * 1000,
								).toLocaleDateString()), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: _normalizeClass(["btn btn-sm btn-tertiary ccard__pin-btn", { active: _ctx.isPinned }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.togglePin($event)), ["stop"]))
      }, [
        _createVNode(_component_IconBase, null, {
          default: _withCtx(() => [
            _createVNode(_component_IconBookmark)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_ripple]
      ])
    ])
  ])), [
    [_directive_shiny_border, {
			height: 2,
			padding: 12,
			hoverRgbaColor: [37, 37, 37, 0.75],
		}]
  ])
}